<div id="cash-transactions-container">
  <div
    filters
    class="d-flex flex-row flex-fill align-items-center filters"
    *ngIf="filter$ | async; let filter"
  >
    <!-- desktop filters -->

    <div class="d-none d-lg-block flex-fill desktop-filters pb-2">
      <div class="d-flex flex-row flex-fill">
        <!-- type filter -->
        <button
          class="badge badge-primary p-1 me-1 btn-trancation-type d-flex align-items-center"
          mat-button
          [matMenuTriggerFor]="menuType"
        >
          Type
          <span class="ms-2 badge badge-light">{{
            selectedType$ | async
          }}</span>
          <mat-icon class="show_more">keyboard_arrow_down</mat-icon>
        </button>

        <!-- status filter -->
        <button
          class="badge badge-primary p-1 me-1 btn-trancation-type d-flex align-items-center"
          mat-button
          [matMenuTriggerFor]="menuStatus"
        >
          Description
          <span class="badge badge-light ms-2">{{
            selectedDescription$ | async
          }}</span>
          <mat-icon class="show_more">keyboard_arrow_down</mat-icon>
        </button>

        <!-- date filter -->
        <button
          class="badge badge-primary p-1 me-1 btn-trancation-type d-flex align-items-center ps-2"
          mat-button
          [matMenuTriggerFor]="menuDate"
        >
          From:<span class="badge badge-light p-2 m-1">
            {{ filter.value.from | date : "dd/MM/yyyy" | dash }}</span
          >
          To:<span class="badge badge-light p-2 m-1">
            {{ filter.value.to | date : "dd/MM/yyyy" | dash }}</span
          >
          <mat-icon class="show_more">keyboard_arrow_down</mat-icon>
        </button>
      </div>
    </div>

    <!-- mobile filters -->
    <div class="flex-fill d-md-block d-lg-none">
      <button
        class="p-1 me-1 w-100 btn-trancation-type d-flex align-items-center justify-content-start"
        mat-button
        [matMenuTriggerFor]="filterMenu"
      >
        Filters:
        <mat-icon class="show_more">keyboard_arrow_down</mat-icon>
      </button>

      <mat-menu #filterMenu="matMenu" class="cash-mobile-menu">
        <!-- type -->
        <button
          class="ms-2 p-1 me-1 w-100 btn-trancation-type d-flex align-items-center"
          mat-menu-item
          [matMenuTriggerFor]="menuType"
        >
          Type
          <span class="ms-2 badge badge-light">{{
            selectedType$ | async
          }}</span>
        </button>

        <!-- status -->
        <button
          class="ms-2 p-1 me-1 w-100 btn-trancation-type d-flex align-items-center"
          mat-menu-item
          [matMenuTriggerFor]="menuStatus"
        >
          Description
          <span class="badge badge-light ms-2">{{
            selectedDescription$ | async
          }}</span>
        </button>

        <!-- date -->
        <button
          *ngIf="filter$ | async; let filter"
          class="ms-2 p-1 me-1 w-100 btn-trancation-type d-flex align-items-center"
          mat-menu-item
          [matMenuTriggerFor]="menuDate"
        >
          From:<span class="badge badge-light m-1">
            {{ filter.value.from | date : "dd/MM/yyyy" | dash }}</span
          >
          To:<span class="badge badge-light m-1">
            {{ filter.value.to | date : "dd/MM/yyyy" | dash }}</span
          >
        </button>
      </mat-menu>
    </div>

    <!-- inner type menu -->
    <mat-menu #menuType="matMenu" class="switch-history-menu cash-transactions">
      <button
        mat-menu-item
        *ngFor="let item of transactionTypes$ | async"
        (click)="selectTransactionType(item.value)"
      >
        <mat-icon>arrow_right</mat-icon>{{ item.value }}
      </button>
    </mat-menu>
    <!-- inner status menu -->
    <mat-menu
      #menuStatus="matMenu"
      class="switch-history-menu cash-transactions"
    >
      <button
        mat-menu-item
        *ngFor="let item of transactionDescription$ | async"
        (click)="selectTransactionDescription(item.key)"
      >
        <mat-icon>arrow_right</mat-icon>{{ item.value }}
      </button>
    </mat-menu>
    <!-- inner date menu -->
    <mat-menu #menuDate="matMenu" class="switch-history-menu p-3">
      <button
        *ngIf="(filter$ | async)?.controls; let filter"
        mat-menu-item
        class="d-flex align-items-center"
        (click)="clearYear()"
      >
        <mat-icon>close</mat-icon>
        Clear dates
      </button>
      <button
        class="d-flex align-items-center"
        *ngIf="(filter$ | async)?.controls; let filter"
        mat-menu-item
        (click)="currentFinancialYear()"
      >
        <mat-icon>date_range</mat-icon>Current financial year
      </button>
      <button
        class="d-flex align-items-center"
        *ngIf="(filter$ | async)?.controls; let filter"
        mat-menu-item
        (click)="previousFinancialYear()"
      >
        <mat-icon>date_range</mat-icon>Previous financial year
      </button>
      <div
        class="custom-date-select"
        *ngIf="(filter$ | async)?.controls; let filter"
        (click)="$event.stopPropagation()"
      >
        <div class="m-3">
          <div class="d-flex align-items-center mb-3 flex-row">
            <mat-icon class="me-3">edit</mat-icon>Custom dates:
          </div>
          <div class="form-check ps-0 me-3">
            <app-entry-date
              title="From"
              [date]="(filter$ | async)?.controls.from"
            ></app-entry-date>
          </div>
          <div class="form-check ps-0 me-3">
            <app-entry-date
              title="To"
              [date]="(filter$ | async)?.controls.to"
            ></app-entry-date>
          </div>
        </div>
      </div>
    </mat-menu>

    <div end>
      <button mat-icon-button [matMenuTriggerFor]="menuMore">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menuMore="matMenu" class="cash-mobile-menu p-0">
        <button mat-menu-item (click)="onClearFilterClick()">
          Clear filters
        </button>
      </mat-menu>
    </div>
  </div>

  <mat-drawer-container
    class="drawer-container"
    style="max-height: 630px"
    #drawercontent
  >
    <div class="flex-fill m-2">
      <app-no-items
        message="No transaction found"
        *ngIf="(list$ | async)?.length === 0"
      ></app-no-items>

      <div
        class="table-responsive animate__animated"
        *ngIf="(list$ | async)?.length > 0"
        [ngClass]="{ animate__fadeIn: loading }"
      >
        <table
          class="table {{
            'VIEWS.Global.table-default-style' | translate
          }} table-sm "
        >
          <thead class="">
            <tr>
              <th>Transaction date</th>
              <th>Transaction type</th>
              <th>Description</th>
              <th class="text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of list$ | async">
              <td>{{ item.transactionDate | date : "dd MMM yyyy" }}</td>
              <td>{{ item.accountDetailType }}</td>
              <td>{{ item.description }}</td>
              <td class="text-right">{{ item.amount | currency }}</td>
            </tr>
            <tr class="list-total">
              <th></th>
              <td></td>
              <td></td>
              <td class="text-right">{{ listTotal$ | async | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </mat-drawer-container>
</div>
